module.exports = __webpack_public_path__ + "static/media/algo1.7d60adb9.png";